<template>
  <div class="col-md-8 b-r">
    <div class="p-a-md">
      <span class="h5 _500">Target Sales</span><br>
      <small class="text-muted">Target sales progress overview for all outlet</small>
      <loading-spinner v-show="loading"/>

      <!-- empty message -->
      <div 
        v-show="!targetSales.length && !loading" 
        class="m-t-lg">
        <div class="clearfix"/>
        <p class="text-center m-t-lg"> 
          <span class="h5 _500 text-muted"><i class="material-icons md-48">&#xE01D;</i></span><br>
          It seems there are no outlet targets has been setup!
        </p>
        <p class="text-center m-t-xs">
          <button 
            class="md-btn md-raised m-b-sm green p-l-md p-r-md" 
            @click="gotoSetupPage">Set target sales</button>
        </p>
      </div>

      <ul 
        v-show="targetSales.length && !loading" 
        class="list no-padding">
        <li 
          v-for="outlet in targetSales" 
          :key="outlet.id" 
          class="list-item">
          <div class="list-body">
            <div class="m-y-sm pull-left">
              <span>{{ outlet.name }}</span>
            </div>
            <div class="m-y-sm pull-right">
              <span>{{ getFormattedNumber(outlet.total_sales) }}</span>
              <span>/</span>
              <span>{{ getFormattedNumber(outlet.target_value) }}</span>
            </div>
            <div class="progress progress-striped active">
              <div 
                :style="{ width: getBarPercentage(outlet) + '%' }" 
                class="progress-bar primary">
                {{ getTargetPercentage(outlet) }}%
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { filter } from 'lodash';
import numeral from 'numeral';
export default {
    data() {
        return {
            targetSales: [],
            loading: true,
        };
    },

    mounted() {
        this.getOutletTargetSales();
    },
    methods: {
        getOutletTargetSales() {
            let api = Laroute.route(
                'franchise.dashboard.getMonthlyTargetSales',
            );
            this.$http.get(api).then(res => {
                this.targetSales = filter(
                    res.data.data,
                    d => d.target_value > 0,
                );
                this.loading = false;
            });
        },

        getTargetPercentage(data) {
            let percentage = (data.total_sales * 100) / data.target_value;
            return numeral(percentage).format('0.[00]');
        },

        getBarPercentage(data) {
            let percentage = parseFloat(this.getTargetPercentage(data));
            if (isNaN(percentage)) {
                return 0;
            }
            return percentage > 100 ? 100 : percentage;
        },

        getFormattedNumber(data) {
            return numeral(data).format('0,0.00');
        },

        gotoSetupPage() {
            window.location.href = Laroute.route('franchise.setting.index');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/dashboard/dashboard-target-sales.vue